var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-100 h-100 overflow-auto medical-devices-page"},[_c('d-medical-devices')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }